// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (min-width: 769px) {\n#operations .table-wrapper{\n    overflow: hidden;\n}\n}\n", ""]);
// Exports
module.exports = exports;
